export const processForTestId = (input) => {
  let result = input.replace(/\s+/g, '-');
  result = result.toLowerCase();
  result = result.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  return result;
};
